import { Component, OnInit } from '@angular/core';
import {LocalStorageService} from '../../../../../api/services/localStorage';

@Component({
  selector: 'app-competition-details',
  templateUrl: './competition-details.component.html',
  styleUrls: ['./competition-details.component.css']
})
export class CompetitionDetailsComponent implements OnInit {

  selectedIndex: number;

  constructor(private localStorage: LocalStorageService) { }

  ngOnInit(): void {
    if (this.localStorage.get('competitionDetailIndex') !== null) {
      this.selectedIndex = this.localStorage.get('competitionDetailIndex') as number;
    }
  }

}
